// QR codes of the Material page, error correction H so the logo in the centre does not
// hurt scanning. Each row is one line of modules, 1 = dark. Generated with
// qrcode@1.5.4: QRCode.create(url, { errorCorrectionLevel: 'H' }).
// Change a URL only together with its rows.

export const QR_CODES = {
  smart: {
    url: 'https://schick-vienna.at/download',
    rows: [
      '111111100001100011101010101111111',
      '100000100001001011101010101000001',
      '101110101000111010011101101011101',
      '101110101010110100110101101011101',
      '101110100000001001000110001011101',
      '100000100001101101110001001000001',
      '111111101010101010101010101111111',
      '000000000011100100111000100000000',
      '000110110011100110011010000001100',
      '111010010111111011010011010111100',
      '000110101000011011101111000100111',
      '010100010011000011100011110110111',
      '100111111101011011110111101101011',
      '010111000001010100111101110101010',
      '100001100111101110111000010101000',
      '011101010000000001101001111101111',
      '010110100010010111111000001110001',
      '010001000011011101110010101111001',
      '001110111101101110010001000101101',
      '011010011110111100100001111111111',
      '001001111001010110101000100101000',
      '111010001111111101011111000110100',
      '101000110001000000101011001100011',
      '100001010101110000110000000000110',
      '111111100001011011000000111111010',
      '000000001110011101101100100011000',
      '111111101101111110000001101010000',
      '100000100111000000101111100011110',
      '101110101000111101100111111111010',
      '101110101011101111100011010100101',
      '101110100101010111110100000010011',
      '100000100010000001100100011001111',
      '111111100110011011011011101010000',
    ],
  },
  appStore: {
    url: 'https://apps.apple.com/at/app/id6809869578',
    rows: [
      '1111111000100110100111010000001111111',
      '1000001001110110011010001010101000001',
      '1011101000010101000111111100001011101',
      '1011101001011101100011101101001011101',
      '1011101011010011111110101111001011101',
      '1000001000010100110110110010001000001',
      '1111111010101010101010101010101111111',
      '0000000010000110111010011111100000000',
      '0011001110011101011101010111011010000',
      '0110100101100101100100000101011111100',
      '1010101000011110000010100100110100110',
      '0110110011000010010110111110100110010',
      '0000111001010101111000110111111011110',
      '0001010010000110001110110111101010101',
      '1010111011000011000011111010100100110',
      '0100010111110101101000011001001100001',
      '1010011110010110110100001100000101110',
      '0101100011011011110110011001011000101',
      '0101101010101010101001010111010100111',
      '1011100000101010011000000000101010010',
      '1111011011100011000111100011110010000',
      '0011010101000000011110110000000100100',
      '0111101101011000001111110010011011110',
      '1010110100010011101110001111100001100',
      '0011011000101100100001010000001111101',
      '0010000101100010101110110000110000111',
      '0111111100001001001110101101100110110',
      '1000000111011010101101101010110100110',
      '0000111010011000101000011101111111101',
      '0000000011100011111001000111100011111',
      '1111111010011010001001101100101011011',
      '1000001001011111001100011001100011010',
      '1011101001110111010100000010111111000',
      '1011101010011101011010000100001110100',
      '1011101010110101001101100010001110110',
      '1000001001111100010001011110000001100',
      '1111111000001100111010111110001001111',
    ],
  },
};
